import React, { ChangeEvent, useEffect, useRef, useState } from 'react'
import { enumHLSearchDataType } from '../../VisualunitHelpers'
import { TGetFilterVal } from './GenericFilters'
import { IHLreturnData, updateDurationsFilterInputs } from '../VuParamsHelpers'
import DatePicker from '../DatePicker/DatePicker'

const replaceFilterValueParameter_HLDate = (
    replacedStr: any,
    listItemId: any,
    filterableId: any,
    filterValueListId: any,
    filterValueText: string,
    GetFilterValues: (filterValArgs: TGetFilterVal) => void,
    selectedItem: string,
    selectedParameters: any,
    MetadataId: number
) => {
    const arrayHLDateYears: string[] = [] //["2012", "2013", "2014", "2015", "2016", "2017"],
    const arrayHLDateMonths = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ]
    const arrayHLDateWeekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    const [datevalue, setDatevalue] = useState('')
    const [multipleDates, setMultipleDates] = useState<string[]>([]) // State for multiple date inputs
    const [HLMonths, setHLMonths] = useState<number[]>([])
    const [HLYears, setHLYears] = useState<number[]>([])
    const [HLWeekdays, setHLWeekdays] = useState<number[]>([])
    const [inputValues, setInputValues] = useState<IHLreturnData>({
        HLDATE_FROM: null,
        HLDATE_TO: null,
        HLTIME_FROM: "12:00 am",
        HLTIME_TO: "11:59 pm",
        HLDATE_PERIOD1: "today",
        HLDATE_YEARS: [],
        HLDATE_MONTHS: [],
        HLNUMBER: null,
        HLDATETIME_PERIOD: 'hours',
        HLDATE_PERIOD3: "month",
        HLDATE_YEAR: "1",
        HLDATE_MULTIPLE_DATES: [],
        HLDATE_WEEKDAYS: [],
        HLDATE_PERIOD2: "week",
        HLDATE_RELATIVE_RANGE_2: "",
        HLDATE_RELATIVE_RANGE_3: "hours",
        HLDATE_RELATIVE_RANGE_4: "",
        HLDATE_RELATIVE_RANGE_5: "hours",
        HLDATE_New_RELATIVE_RANGE_2: "",
        HLDATE_New_RELATIVE_RANGE_1: "",
        HLDATE_New_RELATIVE_RANGE_3: ""
    })
    const [updateParent, setUpdateParent] = useState<null | boolean>(null)

    useEffect(()=>{
        if(selectedParameters.data !== null){
            if(selectedParameters.data.filterValueListId == filterValueListId && selectedParameters.data.metaDataId == MetadataId){
                updateDurationsFilterInputs(setInputValues, "HLDATE", selectedParameters, {setHLMonths,
                    setHLYears,
                    setMultipleDates,
                    setHLWeekdays})
                    setUpdateParent(true)
            }
        }else{
            setUpdateParent(false)
        }
    }, [])

    useEffect(() => { //FP-11927- Use effect order change, there is no changes except that
        if (selectedItem != null) {
            if (updateParent !== null) {
                setTimeout(()=>{
                    GetFilterValues({ displayText: filterValueText, selectedValues: inputValues, keyValue: filterValueListId })
                },300)
            }
        }
    }, [selectedItem, updateParent])

    const buildHLTimeFromComponent = (defValue: string) => {
        const extraTime = '11:59 pm'
        const arrayTimeHours = [
            '12',
            '01',
            '02',
            '03',
            '04',
            '05',
            '06',
            '07',
            '08',
            '09',
            '10',
            '11',
        ]
        const arrayTimeMins = ['00', '15', '30', '45']

        const timeOptions = []

        // AM Time options
        arrayTimeHours.forEach((hour) => {
            arrayTimeMins.forEach((min) => {
                const timeFromValue = `${hour}:${min} am`
                timeOptions.push(
                    <option
                        key={timeFromValue}
                        value={timeFromValue}
                        selected={timeFromValue === defValue}
                    >
                        {timeFromValue}
                    </option>
                )
            })
        })

        // PM Time options
        arrayTimeHours.forEach((hour) => {
            arrayTimeMins.forEach((min) => {
                const timeFromValue = `${hour}:${min} pm`
                timeOptions.push(
                    <option
                        key={timeFromValue}
                        value={timeFromValue}
                        selected={timeFromValue === defValue}
                    >
                        {timeFromValue}
                    </option>
                )
            })
        })

        // Extra time option
        timeOptions.push(
            <option key={extraTime} value={extraTime} 
            selected={extraTime === defValue}
            >
                {extraTime}
            </option>
        )

        return <>{timeOptions}</>
    }

    const buildHLTimeToComponent = (defValue: string) => {
        const extraTime = '11:59 pm'
        const arrayTimeHours = [
            '12',
            '01',
            '02',
            '03',
            '04',
            '05',
            '06',
            '07',
            '08',
            '09',
            '10',
            '11',
        ]
        const arrayTimeMins = ['00', '15', '30', '45']

        const timeOptions = []

        // AM Time options
        arrayTimeHours.forEach((hour) => {
            arrayTimeMins.forEach((min) => {
                const timeToValue = `${hour}:${min} am`
                timeOptions.push(
                    <option
                        key={timeToValue}
                        value={timeToValue}
                        selected={timeToValue === defValue}
                    >
                        {timeToValue}
                    </option>
                )
            })
        })

        // PM Time options
        arrayTimeHours.forEach((hour) => {
            arrayTimeMins.forEach((min) => {
                const timeToValue = `${hour}:${min} pm`
                timeOptions.push(
                    <option
                        key={timeToValue}
                        value={timeToValue}
                        selected={timeToValue === defValue}
                    >
                        {timeToValue}
                    </option>
                )
            })
        })

        // Extra time option
        timeOptions.push(
            <option key={extraTime} value={extraTime} 
            selected={extraTime === defValue}
            >
                {extraTime}
            </option>
        )

        return <>{timeOptions}</>
    }

    const buildHLDateTimePeriodOptions = (defValue: string) => {
        const periods = [
            'minutes',
            'hours',
            'days',
            'weeks',
            'weekends',
            'weeks - weekdays',
            'months',
            'quarters',
            'years',
            'fiscal years',
        ]

        return (
            <>
                {periods.map((period, index) => (
                    <option key={`filter_periods_${index}`} value={period} 
                    selected={period === defValue}
                    >
                        {period}
                    </option>
                ))}
            </>
        )
    }

    const buildHLDatePeriod1Options = (defValue: string) => {
        const periods = ['today', 'tomorrow', 'yesterday']

        return (
            <>
                {periods.map((period, index) => (
                    <option key={`period_${index}`} value={period} 
                    selected={period === defValue}
                    defaultValue={defValue}
                    >
                        {period}
                    </option>
                ))}
            </>
        )
    }

    const buildHLTimeZoneOptions = (defValue?: string) => {
        const timeZones = ['PST', 'EST', 'CST']

        return (
            <>
                {timeZones.map((zone,index) => (
                    <option key={`filter_zone_${index}`} value={zone} 
                    // selected={zone === defValue}
                    >
                        {zone}
                    </option>
                ))}
            </>
        )
    }

    const buildHLDatePeriod2Options = (defValue: string) => {
        const periods = ['week', 'month', 'quarter', 'year', 'fiscal year']

        return (
            <>
                {periods.map((period, index) => (
                    <option key={`period_weakYear_${index}`} value={period} 
                    selected={period === defValue}
                    >
                        {period}
                    </option>
                ))}
            </>
        )
    }

    const buildHLDatePeriod3Options = (defValue: string) => {
        const periods = ['month', 'quarter', 'year', 'fiscal year']

        return (
            <>
                {periods.map((period, index) => (
                    <option key={`period_monthQuarter_${index}`} value={period} 
                    selected={period === defValue}
                    >
                        {period}
                    </option>
                ))}
            </>
        )
    }
    
    const updateInputState = (value: any, key: string) =>{
        let inputValToFormat = value;
        // if(key === enumHLSearchDataType.HLDate_To || 
        //     key === enumHLSearchDataType.HLDate_From || 
        //     key === `${enumHLSearchDataType.HLDATE_New_RELATIVE_RANGE}_1` ){
        //     inputValToFormat = changeDateFormat(value, "MM/DD/YYYY")
        // }
        let currentInputs = {...inputValues}
        currentInputs = {
            ...currentInputs,
            [key]: inputValToFormat === "" ? undefined : inputValToFormat
        }
        setInputValues(currentInputs)
                
        // This handled in UseEffect FP-12056 GetFilterValues({displayText: filterValueText, selectedValues: currentInputs, keyValue: filterValueListId})
        setUpdateParent(!updateParent)
    }
    const getValuesFromDateInput = (key: string, event: React.ChangeEvent<HTMLSelectElement> | ChangeEvent<HTMLInputElement>) => {
        event.stopPropagation()
        updateInputState(event.target.value, key)
    }

    // Handle date change in the input
    const handleDateChange = (index: number, value: string) => {
        // event.preventDefault()
        let dateVal = value
        setDatevalue(dateVal)
        // let formedDate = changeDateFormat(dateVal, "MM/DD/YYYY")
        const updatedDates = [...multipleDates]
        updatedDates[index] = dateVal
        setMultipleDates(updatedDates)
        updateInputState(updatedDates, enumHLSearchDataType.HLDate_Multiple_Dates)
    }

    const handleTimePeriodChange = (value: number| string , setState: any, initState: any[], period: string)=>{
        //FP-11206 Metadata Pallet merging common functions into one...
        // event.stopPropagation() //FP-11206 in this case user have to click on Entire box to see the added inputs... that's why its commented.
        let copyPeriodArray = [...initState]
        if(copyPeriodArray.includes(value)){
            copyPeriodArray = copyPeriodArray.filter((month) => month !== value)
        }else{
            copyPeriodArray= [...copyPeriodArray, value]
        }
        setState(copyPeriodArray)
        updateInputState(copyPeriodArray, period)
    }

    const removeDatefromMultipleDates = (value: string) => {
        setMultipleDates((prevDates) => prevDates.filter((date) => date !== value))
    }
    // Define the parseReplacedStr function to handle the replacement logic
    const parseReplacedStr = (str: string) => {
        const regex = new RegExp(
            `\\[(${enumHLSearchDataType.HLDate_Period1}|${enumHLSearchDataType.HLDate_From}|${enumHLSearchDataType.HLTime_From}|${enumHLSearchDataType.HLDate_To}|${enumHLSearchDataType.HLTime_To}|${enumHLSearchDataType.HLTime_Zone}|${enumHLSearchDataType.HLDate_Years}|${enumHLSearchDataType.HLDate_Months}|${enumHLSearchDataType.HLDate_Multiple_Dates}|${enumHLSearchDataType.HLDate_Weekdays}|${enumHLSearchDataType.HLDateTime_Number}|${enumHLSearchDataType.HLDateTime_Period}|${enumHLSearchDataType.HLDate_Period2}|${enumHLSearchDataType.HLDate_Period3}|${enumHLSearchDataType.HLDate_Year}|${enumHLSearchDataType.HLDate_Relative_Range}|${enumHLSearchDataType.HLDATE_New_RELATIVE_RANGE}|${enumHLSearchDataType.HLNumber})\\]`,
            'gi'
        )

        let parts = str.split(regex).filter(Boolean) // Split by placeholders and remove empty parts
        if (
            parts[0] === enumHLSearchDataType.HLDate_Years &&
            parts[2] === enumHLSearchDataType.HLDate_Months
        ) {
            parts = [enumHLSearchDataType.HLDate_Years_Months] //chetan:- temporary solution need to change this or we can ask data engineering team to use this new "HLDate_Years_Months" place holder in the place of two different placeholders.
        }
        const jsxParts = parts.map((part, index) => {
            // Handle HLDate_Period1 placeholder
            if (part === enumHLSearchDataType.HLDate_Period1) {
                return (
                    <select
                        key={`${listItemId}_${enumHLSearchDataType.HLDate_Period1}_${index}`}
                        id={`${listItemId}_${enumHLSearchDataType.HLDate_Period1}`}
                        className="filtervalue-input-select"
                        onChange={(e) =>
                            getValuesFromDateInput(enumHLSearchDataType.HLDate_Period1, e)
                        }
                    >
                        {buildHLDatePeriod1Options(inputValues.HLDATE_PERIOD1 ?? 'today')}
                    </select>
                )
            }

            // Handle HLDate_From placeholder (start of range)
            if (part === enumHLSearchDataType.HLDate_From) {
                return (
                    <DatePicker
                        dateFormat={'MM/DD/YYYY'}
                        classes='d-flex align-items-center'
                        placeholder=""
                        interval={1}
                        showIcon={false}
                        showTime={false}
                        onKeyDown={(e) => {
                            e.preventDefault()
                        }}
                        setStartingDate={(dateValue: string) => updateInputState(dateValue, enumHLSearchDataType.HLDate_From)}
                        startingDate={inputValues.HLDATE_FROM} //this is default values
                        showUnicornDateIcon={true}
                    />
                )
            }

            // Handle HLTime_From placeholder
            if (part === enumHLSearchDataType.HLTime_From) {
                return (
                    <select
                        key={`HLTime_From_${index}`}
                        id={`${listItemId}_${enumHLSearchDataType.HLTime_From}`}
                        className="filtervalue-input-select"
                        onChange={(e) => getValuesFromDateInput(enumHLSearchDataType.HLTime_From, e)}
                    >
                        {buildHLTimeFromComponent(inputValues.HLTIME_FROM)}
                    </select>
                )
            }

            // Handle HLDate_To placeholder (end of range)
            if (part === enumHLSearchDataType.HLDate_To) {
                return (
                    <DatePicker
                        dateFormat={'MM/DD/YYYY'}
                        classes='d-flex align-items-center'
                        placeholder=""
                        interval={1}
                        showIcon={false}
                        showTime={false}
                        onKeyDown={(e) => {
                            e.preventDefault()
                        }}
                        setStartingDate={(dateValue: string) => updateInputState(dateValue, enumHLSearchDataType.HLDate_To)}
                        startingDate={inputValues.HLDATE_TO}
                        showUnicornDateIcon={true}
                    />
                )
            }

            // Handle HLTime_To placeholder
            if (part === enumHLSearchDataType.HLTime_To) {
                return (
                    <select
                        key={`HLTime_To_${index}`}
                        id={`${listItemId}_${enumHLSearchDataType.HLTime_To}`}
                        className="filtervalue-input-select"
                        onChange={(e) => getValuesFromDateInput(enumHLSearchDataType.HLTime_To, e)}
                    >
                        {buildHLTimeToComponent(inputValues.HLTIME_TO)}
                    </select>
                )
            }

            // Handle HLTime_Zone placeholder
            if (part === enumHLSearchDataType.HLTime_Zone) {
                return (
                    <select
                        key={`HLTime_Zone_${index}`}
                        id={`${listItemId}_${enumHLSearchDataType.HLTime_Zone}`}
                        className="filtervalue-input-select"
                        onChange={(e) => getValuesFromDateInput(enumHLSearchDataType.HLTime_Zone, e)}
                    >
                        {buildHLTimeZoneOptions()}
                    </select>
                )
            }

            // Handle HLDate_Years and HLDate_Months (specific range cases)
            if (part === enumHLSearchDataType.HLDate_Years_Months) {
                if (arrayHLDateYears.length == 0) {
                    let thisyear = new Date().getFullYear()
                    arrayHLDateYears.push(
                        (thisyear - 3).toString(),
                        (thisyear - 2).toString(),
                        (thisyear - 1).toString(),
                        thisyear.toString(),
                        (thisyear + 1).toString(),
                        (thisyear + 2).toString()
                    )
                }
                
                return (
                    <>
                        specific years and months: 
                        
                        <div className="filtervalue-input-year-wrapper">
                        {arrayHLDateYears.map((year, i) => (
                            <span
                                key={`filtervalue_input_year_${i}`}
                                id={`filtervalue_input_year_${year}`}
                                className={`filtervalue-input-year ${
                                    HLYears.includes(parseInt(year))
                                        ? 'filtervalue-input-year-selected filtervalue-input-year-enabled'
                                        : 'filtervalue-input-year-disabled'
                                }`}
                                onClick={(e) => {handleTimePeriodChange(parseInt(year), setHLYears, HLYears, enumHLSearchDataType.HLDate_Years)}}
                            >
                                {year}
                            </span>
                        ))}
                    </div>
                        <div className="padding-top-medium"></div> <div className="filtervalue-input-month-wrapper">
                        {arrayHLDateMonths.map((month, index) => (
                            <>
                                {index === 6 && <div className="padding-top-medium"></div>}
                                <span
                                    key={`filtervalue_input_month_${index + 1}`}
                                    id={`filtervalue_input_month_${index + 1}`}
                                    className={`filtervalue-input-month ${
                                        HLMonths.includes(index)
                                            ? 'filtervalue-input-month-selected filtervalue-input-month-enabled'
                                            : 'filtervalue-input-month-disabled'
                                    }`}
                                    onClick={(e) => handleTimePeriodChange(index, setHLMonths, HLMonths, enumHLSearchDataType.HLDate_Months)}
                                >
                                    {month}
                                </span>
                            </>
                        ))}
                    </div>
                    </>
                )
            }
            // Handle HLDate_Multiple_Dates (multiple dates scenario)
            if (part === enumHLSearchDataType.HLDate_Multiple_Dates) {
                return (
                    <React.Fragment key={`HLDate_Multiple_Dates_${index}`}>
                        multiple dates:
                        <div className="filtervalue-input-multidates-adddate-wrapper">
                            <DatePicker
                            // FP-12056 Adding date picker library, on month select date getting auto selected
                                dateFormat={'MM/DD/YYYY'}
                                classes='d-flex align-items-center'
                                placeholder=""
                                interval={1}
                                showIcon={false}
                                showTime={false}
                                onKeyDown={(e) => {
                                    e.preventDefault()
                                }}
                                setStartingDate={(e: any) => { handleDateChange(multipleDates.length, e) }
                                }
                                startingDate={null}
                                showUnicornDateIcon={true}
                            />
                        </div>
                        <div className="filtervalue-input-multidate-list-wrapper">
                            {multipleDates.map((date, i) => (
                                <div key={`filterValue_multipleDates_${i}`} className="filtervalue-input-multidate-date">
                                    <span key={i} className="filtervalue-input-multidate">
                                        {date || ''}
                                    </span>
                                    <a
                                        className="filtervalue-input-multidate-date-delete-container"
                                        onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                                            e.stopPropagation()
                                            removeDatefromMultipleDates(date) // Call the function with the correct value
                                        }}
                                    >
                                        <span className="filtervalue-input-multidate-date-delete"></span>
                                    </a>
                                </div>
                            ))}
                        </div>
                    </React.Fragment>
                )
            }

            if (part === enumHLSearchDataType.HLDate_Weekdays) {
                return (
                    <>
                        specific weekdays:
                        <div className="filtervalue-input-weekday-wrapper">
                            {arrayHLDateWeekdays.map((weekday, index) => (
                                <span
                                    key={`filtervalue_input_weekday_${index}`}
                                    id={`filtervalue_input_weekday_${index + 1}`}
                                    className={`filtervalue-input-weekday ${
                                        HLWeekdays.includes(index)
                                            ? 'filtervalue-input-weekday-selected filtervalue-input-weekday-enabled'
                                            : 'filtervalue-input-weekday-disabled'
                                    }`}
                                    onClick={(e) => handleTimePeriodChange(index, setHLWeekdays, HLWeekdays, enumHLSearchDataType.HLDate_Weekdays)}
                                >
                                    {weekday}
                                </span>
                            ))}
                        </div>
                    </>
                )
            }

            // Handle HLDateTime_Number placeholder
            if (part === enumHLSearchDataType.HLDateTime_Number) {
                return (
                    <input
                        key={`HLDateTime_Number_${index}`}
                        type="text"
                        id={`${listItemId}_${enumHLSearchDataType.HLDateTime_Number}`}
                        size={3}
                        defaultValue={inputValues?.HLDATETIME_NUMBER}
                        maxLength={3}
                        autoComplete="off"
                        className="filtervalue-input-text input-numeric"
                        onChange={(e) =>
                            getValuesFromDateInput(enumHLSearchDataType.HLDateTime_Number, e)
                        }
                    />
                )
            }

            // Handle HLDateTime_Period placeholder
            if (part === enumHLSearchDataType.HLDateTime_Period) {
                return (
                    <select
                        key={`HLDateTime_Period_${index}`}
                        id={`${listItemId}_${enumHLSearchDataType.HLDateTime_Period}`}
                        className="filtervalue-input-select"
                        onChange={(e) =>
                            getValuesFromDateInput(enumHLSearchDataType.HLDateTime_Period, e)
                        }
                    >
                        {buildHLDateTimePeriodOptions(inputValues.HLDATETIME_PERIOD ?? 'hours')}
                    </select>
                )
            }

            // Handle HLDate_Period2 placeholder
            if (part === enumHLSearchDataType.HLDate_Period2) {
                return (
                    <select
                        key={`HLDate_Period2_${index}`}
                        id={`${listItemId}_${enumHLSearchDataType.HLDate_Period2}`}
                        className="filtervalue-input-select"
                        onChange={(e) =>
                            getValuesFromDateInput(enumHLSearchDataType.HLDate_Period2, e)
                        }
                    >
                        {buildHLDatePeriod2Options( inputValues?.HLDATE_PERIOD2 ?? 'week')}
                    </select>
                )
            }

            // Handle HLDate_Period3 placeholder
            if (part === enumHLSearchDataType.HLDate_Period3) {
                return (
                    <select
                        key={`HLDate_Period3_${index}`}
                        id={`${listItemId}_${enumHLSearchDataType.HLDate_Period3}`}
                        onChange={(e) =>
                            getValuesFromDateInput(enumHLSearchDataType.HLDate_Period3, e)
                        }
                        className="filtervalue-input-select"
                    >
                        {buildHLDatePeriod3Options(inputValues?.HLDATE_PERIOD3 ?? 'month')}
                    </select>
                )
            }

            // Handle HLDate_Year placeholder
            if (part === enumHLSearchDataType.HLDate_Year) {
                return (
                    <input
                        key={`HLDate_Year_${index}`}
                        type="text"
                        id={`${listItemId}_${enumHLSearchDataType.HLDate_Year}`}
                        size={3}
                        maxLength={3}
                        value={inputValues.HLDATE_YEAR}
                        autoComplete="off"
                        className="filtervalue-input-text input-numeric"
                        onChange={(e) => getValuesFromDateInput(enumHLSearchDataType.HLDate_Year, e)}
                    />
                )
            }

            // Handle HLDate_Relative_Range placeholder
            if (part === enumHLSearchDataType.HLDate_Relative_Range) {
                let rangeMinus = (
                    <>
                        <div className="minus">minus</div>
                        <input
                            key={`HLDate_Relative_Range_Input_${index}`}
                            type="text"
                            id={`${listItemId}_${enumHLSearchDataType.HLDate_Relative_Range}_2`}
                            size={3}
                            maxLength={3}
                            value={inputValues?.HLDATE_RELATIVE_RANGE_2}
                            autoComplete="off"
                            className="filtervalue-input-text input-numeric"
                            onChange={(e) =>
                                getValuesFromDateInput(
                                    `${enumHLSearchDataType.HLDate_Relative_Range}_2`,
                                    e
                                )
                            }
                        />
                        <select
                            key={`HLDate_Relative_Range_Select_${index}`}
                            id={`${listItemId}_${enumHLSearchDataType.HLDate_Relative_Range}_3`}
                            className="filtervalue-input-select"
                            // defaultValue={'hours'}
                            onChange={(e) =>
                                getValuesFromDateInput(
                                    `${enumHLSearchDataType.HLDate_Relative_Range}_3`,
                                    e
                                )
                            }
                        >
                            {buildHLDateTimePeriodOptions( inputValues?.HLDATE_RELATIVE_RANGE_3 || 'hours')}
                        </select>
                    </>
                )

                let rangePlus = (
                    <>
                        <div className="plus">plus</div>
                        <input
                            key={`RangePlus_Input_${index}`}
                            type="text"
                            id={`${listItemId}_${enumHLSearchDataType.HLDate_Relative_Range}_4`}
                            size={3}
                            maxLength={3}
                            value={inputValues?.HLDATE_RELATIVE_RANGE_4}
                            autoComplete="off"
                            className="filtervalue-input-text input-numeric"
                            onChange={(e) =>
                                getValuesFromDateInput(
                                    `${enumHLSearchDataType.HLDate_Relative_Range}_4`,
                                    e
                                )
                            }
                        />
                        <select
                            key={`RangePlus_Select_${index}`}
                            id={`${listItemId}_${enumHLSearchDataType.HLDate_Relative_Range}_5`}
                            className="filtervalue-input-select"
                            // defaultValue={'hours'}
                            onChange={(e) =>
                                getValuesFromDateInput(
                                    `${enumHLSearchDataType.HLDate_Relative_Range}_5`,
                                    e
                                )
                            }
                        >
                            {buildHLDateTimePeriodOptions(inputValues?.HLDATE_RELATIVE_RANGE_5 || 'hours')}
                        </select>
                    </>
                )
                return (
                    <>
                        from today:
                        <div className="filtervalue-input-relrange-minus-wrapper">{rangeMinus}</div>
                        <div className="filtervalue-input-relrange-plus-wrapper">{rangePlus}</div>
                    </>
                )
            }

            // Handle HLDATE_New_RELATIVE_RANGE placeholder
            if (part === enumHLSearchDataType.HLDATE_New_RELATIVE_RANGE) {
                let rangeUpto = (
                    <>
                        <div className="minus">UpTo</div>
                        <input
                            key={`Range_minus_input_${index}`}
                            type="text"
                            id={`${listItemId}_${enumHLSearchDataType.HLDATE_New_RELATIVE_RANGE}_2`}
                            size={3}
                            maxLength={3}
                            autoComplete="off"
                            value={inputValues?.HLDATE_New_RELATIVE_RANGE_2} 
                            className="filtervalue-input-text input-numeric"
                            onChange={(e) =>
                                getValuesFromDateInput(
                                    `${enumHLSearchDataType.HLDATE_New_RELATIVE_RANGE}_2`,
                                    e
                                )
                            }
                        />
                        <select
                            key={`RangePlus_Select_${index}`}
                            id={`${listItemId}_${enumHLSearchDataType.HLDATE_New_RELATIVE_RANGE}_3`}
                            className="filtervalue-input-select"
                            onChange={(e) =>
                                getValuesFromDateInput(
                                    `${enumHLSearchDataType.HLDATE_New_RELATIVE_RANGE}_3`,
                                    e
                                )
                            }
                        >
                            {buildHLDateTimePeriodOptions(inputValues.HLDATE_New_RELATIVE_RANGE_3 || 'hours')}
                        </select>
                    </>
                )

                let rangeDate = (
                    <DatePicker
                        // FP-12056 Adding date picker library, on month select date getting auto selected
                        dateFormat={'MM/DD/YYYY'}
                        classes='d-flex align-items-center'
                        placeholder=""
                        interval={1}
                        showIcon={false}
                        showTime={false}
                        onKeyDown={(e) => {
                            e.preventDefault()
                        }}
                        setStartingDate={(dateValue: string) => updateInputState(dateValue, `${enumHLSearchDataType.HLDATE_New_RELATIVE_RANGE}_1`)}
                        startingDate={inputValues.HLDATE_New_RELATIVE_RANGE_1}
                        showUnicornDateIcon={true}
                    />
                )
                return (
                    <>
                        from {rangeDate}
                        <div className="filtervalue-input-relrange-minus-wrapper">{rangeUpto}</div>
                        Before today
                    </>
                )
            }
            if (part === enumHLSearchDataType.HLNumber) {
                // FP-11206 Removed business parameter check because Business parameter is only available for HLDuration,HLNumber,HLCount, HLMoney, But Its HLNumber=> under HLDATE Case
                return (
                    <input
                        key={`HLNumber_Input_${index}`}
                        type="text"
                        id={`${listItemId}_${enumHLSearchDataType.HLNumber}`}
                        size={10}
                        defaultValue={inputValues.HLNUMBER !== null? inputValues.HLNUMBER : undefined}
                        maxLength={10}
                        autoComplete="off"
                        className="filtervalue-input-text input-decimal"
                        onChange={(e) => getValuesFromDateInput(enumHLSearchDataType.HLNumber, e)}
                    />
                )
            }
            // Return regular text as is
            return part
        })

        return jsxParts
    }

    // Return the JSX for the replaced string
    return <>{parseReplacedStr(replacedStr)}</>
}

export default replaceFilterValueParameter_HLDate
